<div class="info-page">

  <!-- =====================================================
       HEADER
       ===================================================== -->

  <header class="info-header">
    <div class="header-content">

      <div class="brand">
        <img
          src="./assets/logos/faisa-cisal-logo.svg"
          alt="Logo FAISA CISAL"
          class="brand-logo"
        />

        <div class="brand-text">
          <h1>
            Federazione Autonoma Italiana Sindacale Autoferrotranvieri
          </h1>
          <span>
            Segreteria Provinciale di Pistoia
          </span>
        </div>
      </div>

      <a routerLink="/login" class="login-button">
        <i class="pi pi-sign-in"></i>
        <span>Area Iscritti</span>
      </a>

    </div>
  </header>

  <!-- =====================================================
       CONTENUTO PRINCIPALE
       ===================================================== -->

  <main class="info-content">

    <!-- BENVENUTI -->

    <section class="welcome-section">
      <div class="welcome-label">
        <i class="pi pi-info-circle"></i>
        <span>Portale informativo</span>
      </div>

      <h2>Benvenuti</h2>

      <p>
        Ecco il portale informativo della Segreteria
        Provinciale FAISA - CISAL di Pistoia.
      </p>

      <p>
        In questa pagina puoi consultare i prossimi eventi,
        le comunicazioni e le ultime notizie.
      </p>
    </section>

    <!-- =====================================================
         EVENTI E NEWS
         ===================================================== -->

    <div class="content-grid">

      <!-- ===================================================
           EVENTI
           =================================================== -->

      <section class="content-card events-card">

        <div class="card-heading">
          <div class="heading-icon">
            <i class="pi pi-calendar"></i>
          </div>

          <div class="heading-text">
            <h3>Eventi</h3>
            <p>Prossimi appuntamenti</p>
          </div>

          <span
            class="card-counter"
            *ngIf="upcomingEvents.length > 0"
          >
            {{ currentEventIndex + 1 }} / {{ upcomingEvents.length }}
          </span>
        </div>

        <div class="card-body events-card-body loading-host">
          <div *ngIf="isEventsLoading" class="info-loading-overlay" role="status" aria-live="polite" aria-label="Caricamento eventi">
            <img src="assets/icons/loading-spinner.svg" alt="" class="info-loading-spinner" />
            <span>Caricamento eventi...</span>
          </div>

          <ng-container *ngIf="currentEvent as event; else noEvents">

            <article class="content-item event-item">

              <h4 class="event-title">
                {{ event.title }}
              </h4>

              <button
                type="button"
                class="event-preview-button"
                (click)="openEventDialog(event)"
                [attr.aria-label]="'Apri dettagli evento: ' + event.title"
              >

                <ng-container *ngIf="event.flyer; else eventWithoutFlyer">
                  <img
                    class="event-preview-image"
                    [src]="getEventFlyerUrl(event.flyer)"
                    [alt]="'Volantino evento: ' + event.title"
                  />
                </ng-container>

                <ng-template #eventWithoutFlyer>
                  <div class="event-preview-placeholder">
                    <i class="pi pi-calendar"></i>

                    <strong>{{ event.title }}</strong>

                    <span>
                      Visualizza informazioni evento
                    </span>
                  </div>
                </ng-template>

              </button>

              <div class="event-preview-hint">
                <i class="pi pi-info-circle"></i>
                <span>
                  Clicca sull'immagine per i dettagli
                </span>
              </div>

            </article>

            <!-- NAVIGAZIONE EVENTI -->

            <div
              class="card-navigation events-navigation"
              aria-label="Navigazione eventi"
            >
              <button
                type="button"
                class="navigation-button"
                (click)="previousEvent()"
                [disabled]="isEventsLoading || currentEventIndex === 0"
                aria-label="Evento precedente"
              >
                <i class="pi pi-chevron-left"></i>
                <span>Precedente</span>
              </button>

              <button
                type="button"
                class="navigation-button"
                (click)="nextEvent()"
                [disabled]="isEventsLoading || currentEventIndex >= upcomingEvents.length - 1"
                aria-label="Evento successivo"
              >
                <span>Successivo</span>
                <i class="pi pi-chevron-right"></i>
              </button>
            </div>

          </ng-container>

          <ng-template #noEvents>
            <div class="empty-state">
              <i class="pi pi-calendar-times"></i>
              <h4>Nessun evento in programma</h4>
              <p>
                Al momento non sono presenti nuovi appuntamenti.
              </p>
            </div>
          </ng-template>

        </div>
      </section>

      <!-- ===================================================
           NEWS
           =================================================== -->

      <section class="content-card news-card">

        <div class="card-heading">
          <div class="heading-icon">
            <i class="pi pi-megaphone"></i>
          </div>

          <div class="heading-text">
            <h3>News</h3>
            <p>Notizie e comunicazioni</p>
          </div>

          <!-- POSIZIONE NEWS / TOTALE (anche su smartphone) -->

          <span
            class="card-counter"
            *ngIf="sortedNews.length > 0"
          >
            {{ newsCounterLabel }}
          </span>
        </div>

        <div class="card-body news-card-body loading-host">
          <div *ngIf="isNewsLoading" class="info-loading-overlay" role="status" aria-live="polite" aria-label="Caricamento news">
            <img src="assets/icons/loading-spinner.svg" alt="" class="info-loading-spinner" />
            <span>Caricamento news...</span>
          </div>

          <ng-container *ngIf="sortedNews.length > 0; else noNews">

            <!--
              DESKTOP: due news contemporaneamente, una sotto l’altra.
              SMARTPHONE: una sola news, contatore 1/N.
            -->

            <div class="news-list">

              <article
                *ngFor="let item of visibleNews; trackBy: trackByNews"
                class="content-item news-item"
              >

                <div class="item-date">
                  <i class="pi pi-clock"></i>
                  <span>
                    {{
                      parseDate(item.date)
                        | date:'dd MMMM yyyy':'':'it'
                    }}
                  </span>
                </div>

                <h4>
                  {{ item.title }}
                </h4>

                <p class="item-description">
                  {{ item.description }}
                </p>

                <a
                  *ngIf="item.link"
                  class="news-link"
                  [href]="item.link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span>Leggi di più</span>
                  <i class="pi pi-arrow-up-right"></i>
                </a>

              </article>

            </div>

            <!-- NAVIGAZIONE NEWS -->

            <div
              class="card-navigation news-navigation"
              aria-label="Navigazione news"
            >
              <button
                type="button"
                class="navigation-button"
                (click)="previousNews()"
                [disabled]="isNewsLoading || !canGoToPreviousNews"
                aria-label="News precedenti"
              >
                <i class="pi pi-chevron-left"></i>
                <span>Precedente</span>
              </button>

              <button
                type="button"
                class="navigation-button"
                (click)="nextNews()"
                [disabled]="isNewsLoading || !canGoToNextNews"
                aria-label="News successive"
              >
                <span>Successiva</span>
                <i class="pi pi-chevron-right"></i>
              </button>
            </div>

          </ng-container>

          <ng-template #noNews>
            <div class="empty-state">
              <i class="pi pi-inbox"></i>
              <h4>Nessuna notizia disponibile</h4>
              <p>
                Le prossime comunicazioni saranno pubblicate qui.
              </p>
            </div>
          </ng-template>

        </div>
      </section>

    </div>
  </main>

  <!-- =====================================================
       DIALOG DETTAGLI EVENTO
       ===================================================== -->

  <p-dialog
    [(visible)]="eventDialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
    [dismissableMask]="true"
    [blockScroll]="true"
    styleClass="info-event-dialog"
    [header]="selectedEvent?.title || 'Dettagli evento'"
    [style]="{
      width: '800px',
      maxWidth: '95vw'
    }"
    [contentStyle]="{
      padding: '24px 28px',
      maxHeight: '75vh',
      overflow: 'auto'
    }"
    (onHide)="closeEventDialog()"
  >

    <ng-container *ngIf="selectedEvent as event">

      <div class="event-dialog-content">

        <!-- DATA -->

        <div class="event-dialog-date">
          <i class="pi pi-calendar"></i>
          <span>
            {{
              parseDate(event.date)
                | date:'dd MMMM yyyy':'':'it'
            }}
          </span>
        </div>

        <!-- DESCRIZIONE -->

        <div class="event-dialog-description">
          <h4>Informazioni evento</h4>
          <p
            [innerHTML]="formatEventDescription(event.description)"
          ></p>
        </div>

        <!--
          PC: LOCALITÀ | POSTI | PRENOTA | WHATSAPP
          MOBILE: LOCALITÀ | POSTI
                  PRENOTA
                  WHATSAPP
        -->

        <div class="event-details-footer">

          <!-- LOCALITÀ -->

          <div class="event-details-location">
            <ng-container *ngIf="event.location">
              <i class="pi pi-map-marker"></i>
              <span>{{ event.location }}</span>
            </ng-container>
          </div>

          <!-- POSTI DISPONIBILI -->

          <div
            *ngIf="event.avaiable_places !== undefined"
            class="event-available-places"
            [class.places-available]="event.avaiable_places > 5"
            [class.places-limited]="
              event.avaiable_places > 0 &&
              event.avaiable_places <= 5
            "
            [class.places-full]="event.avaiable_places === 0"
          >
            <div class="event-available-icon">
              <i class="pi pi-users"></i>
            </div>

            <div class="event-available-text">
              <span class="event-available-label">
                Posti disponibili
              </span>
              <strong class="event-available-number">
                {{ event.avaiable_places }}
              </strong>
            </div>
          </div>

          <!-- PRENOTA -->

          <button
            *ngIf="event.contacts"
            type="button"
            class="event-booking-button"
            [disabled]="event.avaiable_places === 0"
            (click)="openBookingDialog(event)"
          >
            <i class="pi pi-calendar-plus"></i>
            <span>Prenota</span>
          </button>

          <!-- WHATSAPP -->

          <a
            *ngIf="event.contacts"
            class="event-whatsapp-button"
            [href]="getWhatsAppUrl(event.contacts)"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Contatta il referente su WhatsApp"
          >
            <i class="pi pi-whatsapp"></i>
            <span>WhatsApp</span>
          </a>

        </div>
      </div>
    </ng-container>
  </p-dialog>

  <!-- =====================================================
       DIALOG PRENOTAZIONE
       ===================================================== -->

  <p-dialog
    [(visible)]="bookingDialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
    [dismissableMask]="false"
    [blockScroll]="true"
    [baseZIndex]="11000"
    styleClass="info-booking-dialog"
    header="Prenotazione evento"
    [style]="{
      width: '540px',
      maxWidth: '95vw'
    }"
    [contentStyle]="{
      padding: '1.5rem',
      maxHeight: '75vh',
      overflow: 'auto'
    }"
    (onHide)="closeBookingDialog()"
  >

    <ng-container *ngIf="bookingEvent as event">

      <div class="booking-dialog-content">

        <!-- AVVISO -->

        <div class="booking-warning">
          <div class="booking-warning-title">
            <i class="pi pi-exclamation-triangle"></i>
            <strong>ATTENZIONE</strong>
          </div>

          <p>
            Alla compilazione di questi campi, dopo aver
            confermato si avvierà una chat WhatsApp
            con il referente viaggi.
          </p>

          <p>
            Verrà inserito in automatico un messaggio
            con la prenotazione
            <strong>DA INVIARE</strong>.
          </p>

          <p>
            <strong>
              L'INVIO DEL MESSAGGIO NON SARÀ AUTOMATICO.
            </strong>
          </p>
        </div>

        <!-- EVENTO -->

        <div class="booking-event-summary">
          <i class="pi pi-calendar"></i>
          <div>
            <strong>{{ event.title }}</strong>
            <span>
              {{
                parseDate(event.date)
                  | date:'dd MMMM yyyy':'':'it'
              }}
            </span>
          </div>
        </div>

        <!-- FORM PRENOTAZIONE -->

        <form
          class="booking-form"
          (ngSubmit)="confirmBooking()"
          #bookingForm="ngForm"
        >

          <div class="booking-field">
            <label for="bookingFirstName">
              Nome *
            </label>
            <input
              id="bookingFirstName"
              name="bookingFirstName"
              type="text"
              class="booking-input"
              placeholder="Inserisci il nome"
              autocomplete="given-name"
              maxlength="100"
              required
              [(ngModel)]="booking.firstName"
            />
          </div>

          <div class="booking-field">
            <label for="bookingLastName">
              Cognome *
            </label>
            <input
              id="bookingLastName"
              name="bookingLastName"
              type="text"
              class="booking-input"
              placeholder="Inserisci il cognome"
              autocomplete="family-name"
              maxlength="100"
              required
              [(ngModel)]="booking.lastName"
            />
          </div>

          <div class="booking-field">
            <label for="bookingRegisteredPeople">
              Numero persone ISCRITTE *
            </label>
            <input
              id="bookingRegisteredPeople"
              name="bookingRegisteredPeople"
              type="number"
              class="booking-input"
              min="0"
              step="1"
              inputmode="numeric"
              required
              [(ngModel)]="booking.registeredPeople"
            />
          </div>

          <div class="booking-field">
            <label for="bookingUnregisteredPeople">
              Numero persone NON ISCRITTE *
            </label>
            <input
              id="bookingUnregisteredPeople"
              name="bookingUnregisteredPeople"
              type="number"
              class="booking-input"
              min="0"
              step="1"
              inputmode="numeric"
              required
              [(ngModel)]="booking.unregisteredPeople"
            />
          </div>

          <div class="booking-field">
            <label for="bookingChildren">
              Numero BAMBINI *
            </label>
            <input
              id="bookingChildren"
              name="bookingChildren"
              type="number"
              class="booking-input"
              min="0"
              step="1"
              inputmode="numeric"
              required
              [(ngModel)]="booking.children"
            />
          </div>

          <!-- TOTALE -->

          <div class="booking-total">
            <span>Totale partecipanti</span>
            <strong>{{ bookingTotalPeople }}</strong>
          </div>

          <!-- CONTROLLO DISPONIBILITÀ -->

          <div
            *ngIf="
              event.avaiable_places !== undefined &&
              bookingTotalPeople > event.avaiable_places
            "
            class="booking-validation-error"
          >
            <i class="pi pi-exclamation-circle"></i>
            <span>
              Il numero dei partecipanti supera
              i posti disponibili
              ({{ event.avaiable_places }}).
            </span>
          </div>

          <!-- CONFERMA -->

          <button
            type="submit"
            class="booking-confirm-button"
            [disabled]="!isBookingValid || bookingForm.invalid"
          >
            <i class="pi pi-check"></i>
            <span>Conferma prenotazione</span>
          </button>

        </form>
      </div>
    </ng-container>
  </p-dialog>

</div>